/* global process */
let base = window._env_.VUE_APP_FIN_CENTER_HOST


// 付款科目管理
// 一级
export const subjectFirstLists = params => {
  return axios.post(`${base}/subject/first/lists`, params)
}

export const createSubjectFirst = params => {
  return axios.post(`${base}/subject/first/create`, params)
}

export const enableSubjectFirst = params => {
  return axios.post(`${base}/subject/first/${params.id}/enable`, params)
}

export const disableSubjectFirst = params => {
  return axios.post(`${base}/subject/first/${params.id}/disable`, params)
}

// 二级
export const subjectSecondLists = params => {
  return axios.post(`${base}/subject/second/lists`, params)
}
export const createSubjectSecond = params => {
  return axios.post(`${base}/subject/second/create`, params)
}

export const enableSubjectSecond = params => {
  return axios.post(`${base}/subject/second/${params.id}/enable`, params)
}

export const disableSubjectSecond = params => {
  return axios.post(`${base}/subject/second/${params.id}/disable`, params)
}

export const getFinanceConfigTable = params => {
  return axios.post(`${base}/subject/first/lists`, params)
}

// 科目关系
export const subjectRelationshipLists = params => {
  return axios.post(`${base}/subject/relationship/lists`, params)
}

export const getSubjectRelationship = params => {
  return axios.get(`${base}/subject/relationship/${params.id}`, params)
}

export const createSubjectRelationship = params => {
  return axios.post(`${base}/subject/relationship/create`, params)
}

export const editSubjectRelationship = params => {
  return axios.post(`${base}/subject/relationship/${params.id}/edit`, params)
}

export const batchEditSubjectRelationship = params => {
  return axios.post(`${base}/subject/relationship/batch_edit`, params)
}

export const disableSubjectRelationship = params => {
  return axios.post(`${base}/subject/relationship/${params.id}/disable`, params)
}

export const getMineManagedCompaniesApi = params => {
  return axios.get(`${base}/our_companies/mine_managed`, {params})
}
// 公司账户管理
export const ourCompaniesLists = params => {
  return axios.post(`${base}/our_companies/lists`, params)
}

export const getOurCompanyDetail = params => {
  return axios.get(`${base}/our_companies/${params.id}`)
}

export const createOurCompany = params => {
  return axios.post(`${base}/our_companies/create`, params)
}

export const updateOurCompany = params => {
  return axios.put(`${base}/our_companies/${params.id}`, params)
}

export const enableCompany = params => {
  return axios.post(`${base}/our_companies/${params.id}/enable`, params)
}

export const disableCompany = params => {
  return axios.post(`${base}/our_companies/${params.id}/disable`, params)
}

// 开票名称管理
export const invoiceNameLists = params => {
  return axios.post(`${base}/receipt-applications/invoice_name/lists`, params)
}

export const getInvoiceName = params => {
  return axios.get(`${base}/receipt-applications/invoice_name/${params.id}`)
}

export const createInvoiceName = params => {
  return axios.post(`${base}/receipt-applications/invoice_name/create`, params)
}

export const editInvoiceName = params => {
  return axios.post(`${base}/receipt-applications/invoice_name/${params.id}/edit`, params)
}

export const enableInvoiceName = params => {
  return axios.post(`${base}/receipt-applications/invoice_name/${params.id}/enable`, params)
}

export const disableInvoiceName = params => {
  return axios.post(`${base}/receipt-applications/invoice_name/${params.id}/disable`, params)
}

export const batchCreateInvoiceName = params => {
  return axios.post(`${base}/receipt-applications/invoice_name/batch_create`, params)
}
export const allEnabledInvoiceName = params => {
  return axios.get(`${base}/receipt-applications/invoice_name/all_enable`, {params})
}

// 开票名称列表管理 API
export const invoiceNameTypeLists = params => {
  return axios.post(`${base}/receipt-applications/invoice_name/type/lists`, params)
}
export const getInvoiceNameType = params => {
  return axios.get(`${base}/receipt-applications/invoice_name/type/${params.id}`)
}
export const createInvoiceNameType = params => {
  return axios.post(`${base}/receipt-applications/invoice_name/type/create`, params)
}
export const enableInvoiceNameType = params => {
  return axios.post(`${base}/receipt-applications/invoice_name/type/${params.id}/enable`, params)
}
export const disableInvoiceNameType = params => {
  return axios.post(`${base}/receipt-applications/invoice_name/type/${params.id}/disable`, params)
}
// 开票名称列表管理 API 结束

// 部门管理
export const departmentLists = params => {
  return axios.post(`${base}/departments/list`, params)
}

export const getDepartmentJobLists = params => {
  return axios.post(`${base}/departments/department_job/list`, params)
}

export const getDepartmentJobDetail = params => {
  return axios.get(`${base}/departments/department_job/${params.id}`)
}

export const createDepartmentJob = params => {
  return axios.post(`${base}/departments/department_job/create`, params)
}

export const batchCreateDepartmentJob = params => {
  return axios.post(`${base}/departments/department_job/batch_create`, params)
}

export const updateDepartmentJob = params => {
  return axios.put(`${base}/departments/department_job/${params.id}`, params)
}

export const enableDepartmentJob = params => {
  return axios.post(`${base}/departments/department_job/${params.id}/enable`, params)
}

export const disableDepartmentJob = params => {
  return axios.post(`${base}/departments/department_job/${params.id}/disable`, params)
}

export const exportDepartmentJobList = params => {
  return axios.post(`${base}/departments/export_jobs`, params)
}

export const createDepartment = params => {
  return axios.post(`${base}/departments/create`, params)
}

export const enableDepartment = params => {
  return axios.post(`${base}/departments/${params.id}/enable`, params)
}

export const disableDepartment = params => {
  return axios.post(`${base}/departments/${params.id}/disable`, params)
}

// 账户相关
export const getCompanyAccountManagementTable = params => {
  return axios.post(`${base}/our_companies/bank_account/lists`, params)
}

export const getCompanyAccountManagementDetail = params => {
  return axios.get(`${base}/our_companies/bank_account/${params.id}`, params)
}

export const createOurCompanyAccount = params => {
  return axios.post(`${base}/our_companies/bank_account/create`, params)
}

export const updateOurCompanyAccount = params => {
  return axios.put(`${base}/our_companies/bank_account/${params.id}`, params)
}

export const enableOurCompanyAccount = params => {
  return axios.post(`${base}/our_companies/bank_account/${params.id}/enable`, params)
}

export const disableOurCompanyAccount = params => {
  return axios.post(`${base}/our_companies/bank_account/${params.id}/disable`, params)
}

// 公司银行账户 - 银行相关
export const getBankTable = params => {
  return axios.get(`${base}/banks/all`)
}

export const getBankDetail = params => {
  return axios.get(`${base}/banks/${params.id}`, params)
}

// 百旺开票配置项设置
export const saveBaiWangCfg = params => {
  return axios.post(`${base}/settings/bai_wang/save_cfg`, params)
}
export const getBaiWangCfg = params => {
  return axios.get(`${base}/settings/bai_wang/get_cfg`)
}

// 财务邮件通知设置
export const getFinanceEmailNotifyCfg = params => {
  return axios.get(`${base}/settings/finance_email_notify/get_cfg`, {params})
}
export const saveFinanceEmailNotifyCfg = params => {
  return axios.post(`${base}/settings/finance_email_notify/save_cfg`, params)
}



// WEBPACK FOOTER //
// ./src/views/finance-config/finance-config.api.js